import { render, staticRenderFns } from "./BbvaQuotation.vue?vue&type=template&id=9f78010c"
import script from "./BbvaQuotation.vue?vue&type=script&lang=js"
export * from "./BbvaQuotation.vue?vue&type=script&lang=js"
import style0 from "./BbvaQuotation.vue?vue&type=style&index=0&id=9f78010c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports